import React from "react";
import { Flex } from "@radix-ui/themes";
import { MessageAvatarSVG } from "../loadSVG";
import { getAuthorInitials } from "../../entities/Message";
import type { ChatSettingsV2, SvgRadius } from "../../entities/ChatSettingsV2";
import type { Collaborator } from "../../entities/TenantUserTicket";

function CollaboratorAvatar({ name, style, radius }: { name: string, style?: React.CSSProperties, radius: SvgRadius }) {
  return (
    <MessageAvatarSVG
      key={name}
      initials={getAuthorInitials(name)}
      kind="user"
      alt={`${name} Avatar`}
      radius={radius}
      cssOverrides={{ border: "1px solid var(--avatar-stack-border, white)", boxSizing: "border-box", ...style }}
    />
  );
}

interface TicketCollaboratorsProps {
  collaborators?: Collaborator[];
  settings?: ChatSettingsV2;
}

export function TicketCollaborators({
  collaborators,
  settings
}: TicketCollaboratorsProps) {
  if (!collaborators) {
    return <></>;
  }

  return (
    <Flex pt={"1"}>
      {collaborators.map((collaborator, index) => (
        <CollaboratorAvatar key={collaborator.id} name={collaborator.name} style={{
          marginLeft: index > 0 ? "-10px" : "0",
          position: "relative",
          zIndex: index,
          width: "32px",
          height: "32px",
        }} radius={settings?.svgRadius ?? "medium"} />
      ))}
    </Flex>
  );
}
